import React from 'react';
import './App.css';
import { MantineProvider, Flex } from '@mantine/core';
import CategoryPage from './pages/categories/Category';
import ModelsPage from './pages/models/ModelsPage';
import '@mantine/core/styles.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layout/Layout';
import HomePage from './pages/home/HomePage';
import SorterPage from './pages/sorters/SotersPage';
import RecipesPage from './pages/recipes/recipesPage';
import OperationsPage from './pages/operations/OperationsPage';
import ModelsDetailsPage from './pages/modelsDetails/ModelsDetails';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import RecipeDetailsPage from './pages/recipeDetails/recipeDetails';
import OperationDetailsPage from './pages/operationDetails/operationDetails';
import { RecipeProvider } from './context/RecipeContext';
import { SorterProvider } from './context/SorterContext';
import { SorterOptionsProvider } from '../src/context/SorterOptionsContext';
import { OperationsProvider } from './context/OperationsContext';
import { autoLogin } from './auth/autoLogin';
import { useEffect, useState } from 'react';
import {CategoriesProvider} from './context/CategoriesContext'
import { CenterProvider, useCenters } from './context/CenterContext';

//<Route path="categories" element={<CategoryPage />} />

// Everything below the center selection is keyed by the selected center so the
// data providers remount and refetch when the user switches center.
function AppContent() {
  const { selectedCenterId } = useCenters();

  return (
    <CategoriesProvider key={selectedCenterId ?? 'no-center'}>
    <OperationsProvider>
      <SorterOptionsProvider>
        <SorterProvider>
          <RecipeProvider>
            <MantineProvider>
              <Router>
                <Routes>
                  <Route path="/" element={<Layout />}>
                    <Route index element={<Navigate to="home" replace />} />
                    <Route path="home" element={<HomePage />} />
                    <Route path="sorter" element={<SorterPage />} />
                    <Route path="recipes" element={<RecipesPage />} />
                    <Route path="operations" element={<OperationsPage />} />
                    <Route path="recipes/:id" element={<RecipeDetailsPage />} />
                    <Route path="operations/:opId" element={<OperationDetailsPage />} />
                    <Route path="categories" element={<CategoryPage />} />
                    <Route path="models" element={<ModelsPage />} />
                    <Route path="/models/:activeTab/:id" element={<ModelsDetailsPage />} />
                  </Route>
                </Routes>
              </Router>
            </MantineProvider>
          </RecipeProvider>
        </SorterProvider>
      </SorterOptionsProvider>
    </OperationsProvider>
   </CategoriesProvider>

  );
}

function App() {
  const [authReady, setAuthReady] = useState(false);

  // The providers fetch on mount, so wait for the login before rendering them:
  // otherwise their first requests go out without a token.
  useEffect(() => {
    autoLogin()
      .catch((error) => console.error('Auto login failed:', error))
      .finally(() => setAuthReady(true));
  }, []);

  if (!authReady) {
    return null;
  }

  return (
    <CenterProvider>
      <AppContent />
    </CenterProvider>
  );
}

export default App;